import { useState } from "react";
import { MenuOverlay } from "./menuOverlay";
import { HowItWorksView } from "./howItWorksView";
import { FAQView } from "./faqView";

export const MenuView = () => {
  const [menuState, setMenuState] = useState("none"); // "none" | "open" | "howItWorks" | "faq"

  if (menuState === "howItWorks") {
    return <HowItWorksView onClose={() => setMenuState("open")} />;
  }

  if (menuState === "faq") {
    return <FAQView onClose={() => setMenuState("open")} />;
  }

  return (
    <MenuOverlay
      initialOpen={menuState === "open"}
      onHowItWorks={() => setMenuState("howItWorks")}
      onFaqs={() => setMenuState("faq")}
      onDownloadApp={() => {
        window.open("https://apps.apple.com/app/YOUR_APP_ID", "_blank");
      }}
    />
  );
};